import { moActionTypes } from '../actions/moActions';

const MOReducers = (state = {}, action) => {
  switch (action.type) {
    case moActionTypes.GET_MO.LOADING: {
      const { getMOLoading } = action;
      return {
        ...state,
        getMOLoading,
      };
    }
    case moActionTypes.GET_MO.SUCCESS: {
      const { manufacturingOrders } = action;
      return {
        ...state,
        manufacturingOrders,
      };
    }
    case moActionTypes.GET_MO_BY_ID.LOADING: {
      const { getMOByIdLoading } = action;
      return {
        ...state,
        getMOByIdLoading,
      };
    }
    case moActionTypes.GET_MO_BY_ID.SUCCESS: {
      const { selectedMO } = action;
      return {
        ...state,
        selectedMO,
      };
    }
    case moActionTypes.CREATE_MO.LOADING: {
      const { createMOLoading } = action;
      return {
        ...state,
        createMOLoading,
      };
    }
    case moActionTypes.UPDATE_MO.LOADING: {
      const { updateMOLoading } = action;
      return {
        ...state,
        updateMOLoading,
      };
    }
    case moActionTypes.UPDATE_STATUS_MO.LOADING: {
      const { updateMOStatusLoading } = action;
      return {
        ...state,
        updateMOStatusLoading,
      };
    }
    case moActionTypes.CREATE_MO_ADJUSTMENT.LOADING: {
      const { createMOAdjustmentLoading } = action;
      return {
        ...state,
        createMOAdjustmentLoading,
      };
    }
    case moActionTypes.UPDATE_MO_ADJUSTMENT_STATUS.LOADING: {
      const { updateMOAdjustmentStatusLoading } = action;
      return {
        ...state,
        updateMOAdjustmentStatusLoading,
      };
    }
    case moActionTypes.UPDATE_MO_OTHER_CHARGES.LOADING: {
      const { updateMOOtherChargesLoading } = action;
      return {
        ...state,
        updateMOOtherChargesLoading,
      };
    }
    case moActionTypes.DELETE_MO.LOADING: {
      const { deleteMOLoading } = action;
      return {
        ...state,
        deleteMOLoading,
      };
    }
    case moActionTypes.ARCHIVE_MO.LOADING: {
      const { archiveMoLoading } = action;
      return {
        ...state,
        archiveMoLoading,
      };
    }
    case moActionTypes.GET_MO_JOB_WORKS.LOADING: {
      const { getMoJobWorksLoading } = action;
      return {
        ...state,
        getMoJobWorksLoading,
      };
    }
    case moActionTypes.GET_MO_JOB_WORKS.SUCCESS: {
      const { moJobWorks } = action;
      return {
        ...state,
        moJobWorks,
      };
    }
    case moActionTypes.GET_DOWNLOAD_MO.LOADING: {
      const { getDownloadMOLoading } = action;
      return {
        ...state,
        getDownloadMOLoading,
      };
    }
    case moActionTypes.ADD_RM.LOADING: {
      const { addRMLoading } = action;
      return {
        ...state,
        addRMLoading,
      };
    }
    case moActionTypes.REMOVE_RM.LOADING: {
      const { removeRMLoading } = action;
      return {
        ...state,
        removeRMLoading,
      };
    }
    case moActionTypes.SWAP_RM.LOADING: {
      const { swapRMLoading } = action;
      return {
        ...state,
        swapRMLoading,
      };
    }
    case moActionTypes.GET_WORK_ORDER_RM.LOADING: {
      const { getWorkOrderRmLoading } = action;
      return {
        ...state,
        getWorkOrderRmLoading,
      };
    }
    case moActionTypes.GET_WORK_ORDER_RM.SUCCESS: {
      const { workOrderRm } = action;
      return {
        ...state,
        workOrderRm,
      };
    }

    default: {
      return state;
    }
  }
};

export default MOReducers;
